import React, {useState} from 'react';
import {Field, PrimitiveObject} from "../../Types";
import EditField from "./EditField";
import {getColumnValue} from "../functions";
import styled from "styled-components";
import Icon from "../misc/Icon";
import {faLock, faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import NullifyField from "../editFields/NullifyField";
import OpenRefButton from "./refType/OpenRefButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchengin} from "@fortawesome/free-brands-svg-icons";
import SearchRefModal from "./refType/SearchRefModal";

function Column({value, record, schema, cols, pk}: {
    value: string | number | boolean,
    record: PrimitiveObject
    schema: Field,
    cols: number,
    pk: string | number
}) {

    const [isEditing, setIsEditing] = useState(!!schema.inlineEditable);
    const closeEditing = () => setIsEditing(false)


    return <>

        <Container>
            <td className={'edit-title-col'}>

                <div className={'wrapper'}>
                    {schema.searchRef && <div className="side">
                        <SearchRefModal fieldSchema={schema as any} record={record} />
                    </div> }
                    <div className={'title'}>
                        <div className={'main-title'}>
                            {/*<TypeIcon className={'title-icon'} type={schema.type}/>*/}
                            {/*&nbsp;*/}
                            {schema.title.ua}
                        </div>
                        {schema.comment && <small style={{fontSize: '12px'}}>
                            {schema.comment}
                        </small>}
                    </div>
                    <div className="column-controls">
                        {/*{schema.searchRef && <SearchRefModal fieldSchema={schema as any} record={record} /> }*/}
                        {schema.editable && <Button onClick={() => setIsEditing(!isEditing)}>
                            <FontAwesomeIcon icon={faPenToSquare} size={"xl"} className={'fa-color'} />
                        </Button>}
                        {schema.ref && <OpenRefButton fieldSchema={schema as any} record={record}/>}
                    </div>
                </div>

            </td>
            <td className={'value-col'}>
                {!isEditing && schema.type !== "ref" &&
                    <span onClick={() => setIsEditing(!!schema.editable && !schema.applyTransform && true)}>
                {getColumnValue(value, schema, false, record)}
            </span>}
                {schema.type === "ref" && getColumnValue(true, schema, false, record)}
                {isEditing && <EditField value={value} schema={schema} pk={pk} closeEditing={closeEditing}/>}
                {isEditing && schema.nullable &&
                    <NullifyField schema={schema} pk={pk} closeEditing={closeEditing}/>}
            </td>

        </Container>
        {schema.type === "ref" && getColumnValue(value, schema, false, record)}
    </>
}

export default Column;

const Container = styled.tr<any>`
    max-width: 100vw;
    font-size: 1rem;
    line-height: 1.25;

    & > td {

    }

    .value-col {
        width: auto;
    }


    & .edit-title-col {
        text-align: left; /* Aligns text to the left */
        vertical-align: top; /* Vertically centers the content in the cell */
        width: 1%;
        white-space: nowrap;
        //padding-bottom: 1.75rem;


        .wrapper {
            width: 100%;
            display: inline-flex;
            justify-content: left;
            gap: .2rem;
            //align-items: center;
            
            & .column-controls {
                margin-left: auto;
                display: flex;
                gap: .4rem;
            }
            
            & .side {
                margin-left: calc(-1.45rem - var(--td-padding));
                margin-right: .2rem;
            }
        }
    }


    .main-title {
        display: flex;
        align-items: center;
        white-space: nowrap;

        font-weight: bold;
    }

    & .title {
        //width: calc(100% - 1.5rem - 1em);
        //margin-right: 1em; /* Adds space between the title and the button */
        display: inline-flex; /* Allows the margin to take effect */
        flex-flow: column;
        gap: .2rem;
        
    }

    & .btn {
        width: 1.5rem;
        height: 1.5rem;
        display: inline-block;
    }

    & .title-icon {
        width: 1rem;
        height: 1rem;
    }


`

const Button = styled.button`
    cursor: pointer;
    vertical-align: middle;
    margin-left: auto;
    padding: 0;
    border: none;
    display: inline-block;
    vertical-align: middle;
    justify-content: center;
    align-items: center;

    background-color: transparent;

    &[disabled] {
        filter: grayscale(.5);
        cursor: not-allowed;
    }

    & img {
        width: 1rem;
        height: 1rem;
    }

    &:hover {
        filter: brightness(.85);
    }

    //background-image: url("/win-icons/Marking forms.ico") ;
    //background-size: contain;
`
